export default "/_next/static/images/partners-mobile-51579bcf83f6c8d1c61c3d048b8d3bff.png";